import { atomWithStorage, createJSONStorage } from "jotai/utils";

const storeStorage = createJSONStorage(() => sessionStorage);
const storeLocatorListAtom = atomWithStorage(
  "storeLocatorList",
  null,
  storeStorage
);

export default storeLocatorListAtom;
